import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FriendsSurveyComponent } from './friendsSurvey.component';
import { SharedModule } from '@shared/shared.module';
import { FriendsSurveyRoutingModule } from './friendsSurvey-routing.module';
import { CourseContentModule } from '@app/courseContent/courseContent.module';

@NgModule({
  imports: [CommonModule, SharedModule, FriendsSurveyRoutingModule, CourseContentModule],
  declarations: [FriendsSurveyComponent],
})
export class FriendsSurveyModule {}
